import React from "react";
import AuthenticationContainer from "../../components/Authentication/AuthenticationContainer";
import LoginForm from "./components/LoginForm";

const Login = () => {
  return (
    <>
      <AuthenticationContainer Children={<LoginForm />} />
    </>
  );
};

export default Login;
